import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'

/** Fallback when API has not yet returned the org field (e.g. deploy lag). */
export const DEFAULT_NATIONAL_AVG_VOLUNTEER_VALUE_PER_HOUR = 36.14

export function useNationalAvgVolunteerValuePerHour(): number {
  const organization = useCurrentOrg()
  return organization?.nationalAvgVolunteerValuePerHour ?? DEFAULT_NATIONAL_AVG_VOLUNTEER_VALUE_PER_HOUR
}

export default useNationalAvgVolunteerValuePerHour
